<div>
  <shared-modal
    [isOpen]="isOpen()"
    [config]="{
      title: '¿Desea facturar el pedido?',
      size: 'md',
      showCloseButton: true,
      closeOnBackdrop: false,
      closeOnEscape: false
    }"
    [customContent]="true"
    (modalClose)="closeModal()"
  >
    <div class="space-y-6">
      <div class="bg-gray-50 rounded-lg p-4">
        <p class="text-gray-700">El pedido se facturará con los siguientes datos:</p>
        <ul class="mt-3 list-disc pl-6 text-gray-700">
          <li>Número del pedido</li>
          <li>RFC</li>
          <li>Código Postal</li>
          <li>Régimen Fiscal</li>
        </ul>
      </div>

      <div class="bg-gray-50 rounded-lg p-4">
        <p class="text-gray-700">Envía los siguientes datos de facturación al correo electrónico: (Haga clic para copiar)</p>
        <p class="mt-2">
          <a
            [href]="mailtoHref()"
            title="Enviar correo para solicitar factura"
            class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-50 text-yellow-700 font-medium hover:bg-yellow-100 hover:text-yellow-800 transition cursor-pointer"
          >
            {{ email() }}
          </a>
        </p>
      </div>

      <div class="text-sm text-gray-500">
        <p>
          * La solicitud de facturación debe ser dentro del mes en el que se haya realizado el pedido.
        </p>
      </div>


    </div>
  </shared-modal>
</div>
